module.exports = __webpack_public_path__ + "img/series.0f9c9639.svg";